import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { colors } from "../../../ui/colors";

const isNotDelivered = (message) => message?.content?.deliveryStatus === "not-delivered";

export const getMessageStatusTooltip = (isRead, message) =>
  isNotDelivered(message) ? message?.content?.deliveryError || "Not delivered" : isRead ? "Read" : "Delivered";


export const MessageStatus = ({ message, isRead: isReadOverride }) => {
  const isRead = isReadOverride ?? Boolean(message?.readAt);

  if (isNotDelivered(message)) {
    return <ErrorOutlineRoundedIcon sx={{ fontSize: 13, color: colors.red?.[500] ?? "#d32f2f", verticalAlign: "middle" }} />;
  }

  return isRead ? (
    <DoneAllIcon sx={{ fontSize: 13, color: colors.blue[400], verticalAlign: "middle" }} />
  ) : (
    <DoneIcon sx={{ fontSize: 13, color: colors.gray[300], verticalAlign: "middle" }} />
  );
};
